import React from 'react'
import cn from 'classnames'
import 'react-phone-number-input/style.css'
import { Form, Select } from 'util/ui'
import { propFunc } from 'util/functions'
import { disableLastPassInputRef } from 'util/disableLastPassInputRef'
import ValidatedField from 'shared/components/ui/ValidatedField'
import PageHeader from '../PageHeader'
import Button from '../../sharedForm/Button'
import SaveIndicator from '../../sharedForm/SaveIndicator'
import PhoneNumber from '../../sharedForm/PhoneNumber'
import sharedStyles from '../../sharedForm/styles.less'
import { ROLE_OPTIONS_V4 } from '../../sharedForm/constants'

class EmailPage extends React.PureComponent {
  state = {
    focusedField: null,
  }

  handleChange = (name, _, { value }) => {
    const { onChange } = this.props
    onChange(name, value, null, { validate: true })
  }

  handleFocus = name => {
    this.setState({ focusedField: name })
  }

  handleBlur = name => {
    const { onValidate, formFields } = this.props
    if (this.state.focusedField === name) {
      onValidate(name, formFields[name])
    }
    this.setState({ focusedField: null })
  }

  handlePhoneChange = value => {
    this.handleChange('phone', null, { value })
  }

  render() {
    const {
      formFields,
      formFieldsErrors,
      canSave,
      saving,
      submitForm,
    } = this.props
    const { focusedField } = this.state
    return (
      <>
        <PageHeader />
        <Form
          size="large"
          className={cn(sharedStyles.form, sharedStyles.formV3)}
        >
          <Form.Field>
            <label htmlFor="name">Full name</label>
            <ValidatedField
              placeholder="What's your full name?"
              name="name"
              type="text"
              value={formFields.name}
              errorMessage={focusedField !== 'name' && formFieldsErrors.name}
              onChange={propFunc(this.handleChange, 'name')}
              onFocus={propFunc(this.handleFocus, 'name')}
              onBlur={propFunc(this.handleBlur, 'name')}
              fieldRefCallback={disableLastPassInputRef}
              autoFocus
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="companyRole">Your role</label>
            <Select
              name="companyRole"
              className="large"
              options={ROLE_OPTIONS_V4}
              value={formFields.companyRole}
              placeholder="- Please select -"
              onChange={propFunc(this.handleChange, 'companyRole')}
            />
          </Form.Field>
          <Form.Field>
            <label htmlFor="name">Phone number</label>

            <ValidatedField
              id="phone"
              name="phone"
              validatedFieldComponent={PhoneNumber}
              value={formFields.phone}
              onFocus={propFunc(this.handleFocus, 'phone')}
              onBlur={propFunc(this.handleBlur, 'phone')}
              onChange={this.handlePhoneChange}
              errorMessage={focusedField !== 'phone' && formFieldsErrors.phone}
            />
          </Form.Field>
          <Button disabled={!canSave} onClick={submitForm}>
            {!saving ? (
              'Continue'
            ) : (
              <SaveIndicator animate>Saving</SaveIndicator>
            )}
          </Button>
        </Form>
      </>
    )
  }
}

export default EmailPage
